<template>
    <v-card>
        <v-card-title class="pa-0">
            <v-toolbar flat dense color="yellow">
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>
                    Depósito / posición
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn rounded
                       small
                       color="error"
                       @click="save">
                    Guarda
                </v-btn>
            </v-toolbar>

        </v-card-title>

        <v-card-text>
            <v-container grid-list-md>
                <v-row>
                    <v-layout wrap>
                        <v-flex xs12 sm6>
                            <selectDeposito v-model="depositoId"
                                            :texto="depositoNombre"
                                            @change="change">
                            </selectDeposito>
                        </v-flex>

                        <!--  'Puesto' -->
                        <v-flex xs6 sm4>
                            <v-text-field v-model="depositoPuesto.puestoId"
                                          type="number"
                                          label="Puesto">
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-row>
            </v-container>
        </v-card-text>

    </v-card>
</template>

<script>
    import selectDeposito from '@/components/Selects/selectDeposito';

    export default {
        name: 'depositoPuestoDialogo',
        data() {
            return {
                modal: false,
                depositoPuesto: { deposito: { nombre: '' }, puestoId: 0 }
            };
        },

        props: ['item'],

        methods: {
            normalizeItem(item) {
                const depositoPuesto = item
                    ? JSON.parse(JSON.stringify(item))
                    : {};

                if (!depositoPuesto.deposito) {
                    depositoPuesto.deposito = { id: depositoPuesto.depositoId || null, nombre: '' };
                }

                if (depositoPuesto.deposito.nombre == null) {
                    depositoPuesto.deposito.nombre = '';
                }

                if (depositoPuesto.depositoId == null && depositoPuesto.deposito.id != null) {
                    depositoPuesto.depositoId = depositoPuesto.deposito.id;
                }

                return depositoPuesto;
            },

            close() {
                setTimeout(() => {
                    this.$emit('closeDlg');
                }, 300);
            },

            change(item) {
                this.depositoPuesto.deposito = item
                    ? JSON.parse(JSON.stringify(item))
                    : { id: null, nombre: '' };
                this.depositoPuesto.depositoId = this.depositoPuesto.deposito.id;
            },

            save() {
                this.depositoPuesto = this.normalizeItem(this.depositoPuesto);
                this.depositoPuesto.depositoId = this.depositoPuesto.deposito.id;
                this.$emit('change', this.depositoPuesto);
                this.close();
            }
        },

        watch: {
            item: {
                immediate: true,
                handler(item) {
                    this.depositoPuesto = this.normalizeItem(item);
                }
            }
        },

        computed: {
            depositoId: {
                get() {
                    return this.depositoPuesto &&
                        this.depositoPuesto.deposito
                        ? this.depositoPuesto.deposito.id
                        : null;
                },
                set(id) {
                    if (!this.depositoPuesto) {
                        this.depositoPuesto = {};
                    }

                    if (!this.depositoPuesto.deposito) {
                        this.depositoPuesto.deposito = { id: null, nombre: '' };
                    }

                    this.depositoPuesto.deposito.id = id;
                    this.depositoPuesto.depositoId = id;
                }
            },

            depositoNombre() {
                return this.depositoPuesto &&
                    this.depositoPuesto.deposito &&
                    this.depositoPuesto.deposito.nombre
                    ? this.depositoPuesto.deposito.nombre
                    : '';
            }
        },

        components: {
            selectDeposito,
        }
    };
</script>
